import { useNavigate } from "react-router-dom";

// project imports
import { GuardProps } from "types";
import { useEffect } from "react";
import { useSelector } from "react-redux";

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
  const navigate = useNavigate();
  const isValidToken: string = localStorage.getItem("refreshToken") || "";
  const isLoggedIn: string = localStorage.getItem("isLoggedIn") || "";
  const auth = useSelector((state: any) => state.auth);
  const isBrowserVerified = auth.isBrowserVerified;
  const is2FAEnabled = auth.user?.enabled2FA;
  

  useEffect(() => {
    if (!isLoggedIn && !isValidToken) {
      navigate("/login", { replace: true });
    }
    if (!is2FAEnabled) {
      navigate("/login", { replace: true });
    }
    // if (!isBrowserVerified && isLoggedIn) {
    //   navigate("/code-verification", { replace: true });
    // }
  }, [isLoggedIn, isValidToken, isBrowserVerified, is2FAEnabled, navigate]);

  return children;
};

export default AuthGuard;
